import React, { useState } from "react";
import { Box } from "@mui/system";
import StationsService from "../../services/StationsService";
import EventsService from "../../services/EventsService";
import { useTranslation } from "react-i18next";

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";

import { useModal } from "../../common/hooks/useModal";

export default function ListStations({ eventId }: any) {
  /**
   * Se não possui o ID do Evento não carrega o componente
   */
  if (!eventId) {
    return <Box />;
  }

  const navigate = useNavigate();
  const { t } = useTranslation();

  const [stationRemove, setStationRemove] = useState("");

  const [open, setOpen] = React.useState(false);

  const { handleOpenModal, dataModal } = useModal();

  const handleToEdit = (id: number) => {
    //handleOpenModal({ displayName: 'EventStationModal', data: { eventId, idStation: id}})
    navigate(`/events/station/form/${eventId}/${id}`);
  };

  const handleClickOpen = (id: any) => {
    setStationRemove(id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [rows, setRows] = React.useState([]);

  const getStationsByEvent = async (eventId) => {
    await EventsService.getStationsByEvent(eventId)
      .then((response: any) => {
        setRows(response.data);
      })
      .catch((e: Error) => {});
  };

  const removeStation = () => {
    StationsService.remove(stationRemove)
      .then((response: any) => {
        setStationRemove("");
        getStationsByEvent(eventId);
        setOpen(false);
      })
      .catch((e: Error) => {});
  };

  React.useEffect(() => {
    getStationsByEvent(eventId);
  }, [dataModal.loadingBtnClosed, dataModal.loadingBtnSave]);

  return (
    <Box sx={{ mt: 4 }}>
      {rows.length > 0 && (
        <TableContainer component={Paper} sx={{ mt: 5 }}>
          <Table sx={{ minWidth: 600 }} aria-label="custom pagination table">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold', fontSize: 20 }}>{t("list_event_station_namestation")}</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: 20 }}>{t("Avaliadores")}</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: 20 }}>{t("Ferramentas")}</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: 20 }}>{t("Sala")}</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: 20 }}>{t("Tema")}</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: 20 }}>Ações</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row: any, index: number) => (
                <TableRow key={index}>
                  <TableCell>{row.name}</TableCell>
                  <TableCell>
                    <ul>
                      {Array.isArray(row.appraisers_list) && row.appraisers_list.length > 0 ? (
                        row.appraisers_list.map((app: any, idx: number) => (
                          <li key={app.id}>
                            {app.name} <small style={app.role_string == 'student' ? { color: '#e788ffff' } : {}}>{app.role_string}</small>
                          </li>
                        ))
                      ) : (
                        <span>-</span>
                      )}
                    </ul>
                  </TableCell>
                  <TableCell>
                    <ul>
                      <li>{row.scenario_name}</li>
                      <li>{row.checklist_name}</li>
                    </ul>
                  </TableCell>
                  <TableCell>{row.room_name}</TableCell>
                  <TableCell>{row.theme_name}</TableCell>
                  <TableCell>
                    <EditIcon sx={{mr: 2, cursor: 'pointer'}} onClick={() => handleToEdit(row.id)} />
                    <DeleteIcon sx={{cursor: 'pointer'}} onClick={() => handleClickOpen(row.id)} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {t("title_dialog_delete_station")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t("description_dialog_delete_station")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{t("btn_dialog_no")}</Button>
          <Button onClick={removeStation} autoFocus>
            {t("btn_dialog_yes")}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
